var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow-y":"scroll","max-height":"50vh"},domProps:{"innerHTML":_vm._s(_vm.simplifiedSop)}})}
var staticRenderFns = []

export { render, staticRenderFns }